export default "__VITE_ASSET__kDZzdDof__"